import {
  SHOW_FLIGHT_SEARCHER,
  UPDATE_FLIGHT_QUERY,
  SEARCHING_FLIGHT,
  SET_FLIGHT_SEARCH_RESULTS,
  SELECT_FLIGHT_RESULT,
  GETTING_FLIGHT_RESULTS,
  CLEAR_FLIGHT_RESULTS,
  SHOW_FLIGHT_FILTERS,
  SHOW_FLIGHT_SORTER,
  UPDATE_FLIGHT_SORT,
  UPDATE_FLIGHT_FILTERS,
  TOGGLE_FLIGHT_RESULT_DETAILS,
  CANCEL_FLIGHT_SEARCH,
} from '../../../../../types/conversations/plugins'

import moment from 'moment'

const RESET_SELECTED_FLIGHT_RESULTS = 'RESET_SELECTED_FLIGHT_RESULTS'

const initFlightState = {
  productId: '',
  results: [],
  totalResults: 0,
  jobId: '',
  searching: false,
  gettingResults: false,
  jobToken: '',
  searcher: {
    show: false,
    errors: {},
    query: {
      origin: '',
      originplace: '',
      originCountryCode: '',
      destination: '',
      destinationplace: '',
      destinationCountryCode: '',
      outbounddate: moment().format('YYYY-MM-DD'),
      inbounddate: '',
      outbounddepartstarttime: '00:00',
      outbounddepartendtime: '23:59',
      inbounddepartstarttime: '00:00',
      inbounddepartendtime: '23:59',
      cabinclass: 'Economy',
      airlines: [],
      adults: 1,
      children: 0,
      infants: 0,
      // resident: false,
      specialdiscounts: false,
      providers: [],
    },
  },
  filters: {
    show: false,
    type: 'all',
    stops: ['direct', 'one', 'twoOrMore'],
    outboundTime: ['00:00', '23:59'],
    inboundTime: ['00:00', '23:59'],
    travelTime: -1,
    airlines: [],
  },
  sort: {
    show: false,
    active: 'price:asc',
    options: ['price:asc', 'time:asc', 'outboundTime:asc', 'inboundTime:asc', 'airline:asc', 'stops:asc'],
  },
  availableAirlines: null,
  maxTravelTime: -1,
  selectedResults: [],
  detailedResults: [],
}

export default function flight(state = initFlightState, action) {
  switch (action.type) {
    case SHOW_FLIGHT_SEARCHER: {
      const show = !state.searcher.show
      return Object.assign({}, state, {
        searcher: Object.assign({}, state.searcher, { show }),
      })
    }

    case SHOW_FLIGHT_FILTERS: {
      const show = !state.filters.show
      return Object.assign({}, state, {
        filters: Object.assign({}, state.filters, { show }),
      })
    }

    case SHOW_FLIGHT_SORTER: {
      const show = !state.sort.show
      return Object.assign({}, state, {
        sort: Object.assign({}, state.sort, { show }),
      })
    }

    case UPDATE_FLIGHT_SORT: {
      const { sort } = action
      return Object.assign({}, state, {
        sort: Object.assign({}, state.sort, { active: sort }),
      })
    }

    case UPDATE_FLIGHT_FILTERS: {
      const { filters } = action
      return Object.assign({}, state, {
        ...state,
        filters: Object.assign({}, state.filters, filters),
        availableAirlines: state.availableAirlines ? state.availableAirlines : filters.airlines || [],
        maxTravelTime: state.maxTravelTime !== -1 ? state.maxTravelTime : filters.travelTime,
      })
    }

    case UPDATE_FLIGHT_QUERY: {
      const { query } = action
      return Object.assign({}, state, {
        searcher: Object.assign({}, state.searcher, {
          query: Object.assign({}, state.searcher.query, query),
        }),
      })
    }

    case SEARCHING_FLIGHT: {
      const { searching, jobToken } = action
      return Object.assign({}, state, { searching, jobToken })
    }

    case SELECT_FLIGHT_RESULT: {
      const { resultId } = action

      const selectedResults = [].concat(state.selectedResults)
      const flightIndex = state.selectedResults.indexOf(resultId)

      if (flightIndex === -1) selectedResults.push(resultId)
      else selectedResults.splice(flightIndex, 1)

      return Object.assign({}, state, { selectedResults })
    }

    case RESET_SELECTED_FLIGHT_RESULTS: {
      return Object.assign({}, state, { selectedResults: [] })
    }

    case TOGGLE_FLIGHT_RESULT_DETAILS: {
      const { resultId } = action

      const detailedResults = [].concat(state.detailedResults)
      const flightIndex = detailedResults.indexOf(resultId)

      if (flightIndex === -1) detailedResults.push(resultId)
      else detailedResults.splice(flightIndex, 1)

      return Object.assign({}, state, { detailedResults })
    }

    case GETTING_FLIGHT_RESULTS: {
      const { jobId, gettingResults } = action
      return Object.assign({}, state, { jobId, gettingResults })
    }

    case SET_FLIGHT_SEARCH_RESULTS: {
      const { results, totalResults, more } = action

      if (!state.jobToken) return state

      if (!more) {
        const show = !state.searcher.show
        return Object.assign({}, state, {
          results,
          totalResults,
          searcher: Object.assign({}, state.searcher, { show }),
        })
      }

      return Object.assign({}, state, { results: state.results.concat(results), totalResults })
    }

    case CLEAR_FLIGHT_RESULTS: {
      const { results, totalResults, jobId, filters, productId } = initFlightState
      return Object.assign({}, state, {
        results,
        totalResults,
        jobId,
        filters,
        productId,
        gettingResults: false,
      })
    }

    case CANCEL_FLIGHT_SEARCH: {
      const { results, totalResults, jobId, filters, productId, gettingResults, jobToken } = initFlightState
      return Object.assign({}, state, {
        results,
        totalResults,
        jobId,
        jobToken,
        filters,
        productId,
        gettingResults,
        searching: false,
      })
    }

    default: {
      return state
    }
  }
}
